import React from "react";

import * as S from "./BottomButtonContainer.style";

interface Props {
  children: React.ReactNode;
  isSticky?: boolean;
}

const BottomButtonContainer = ({ children, isSticky = false }: Props) => {
  return (
    <S.BottomButtonContainer $isSticky={isSticky}>
      <S.RelativeContainer>
        <S.CenterContainer>{children}</S.CenterContainer>
      </S.RelativeContainer>
    </S.BottomButtonContainer>
  );
};

export default BottomButtonContainer;
